import * as React from "react";
import { Context } from "./_context";
export const NavigationFlashOnIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.403 1.14a.25.25 0 0 1 .346-.076l2.11 1.34a.25.25 0 0 1 .078.344l-5.069 7.983 9.02-.677a1.5 1.5 0 0 1 1.379 2.3l-6.67 10.506a.25.25 0 0 1-.346.077l-2.11-1.341a.25.25 0 0 1-.078-.345l5.069-7.981-9.02.676a1.5 1.5 0 0 1-1.379-2.3l6.67-10.505Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationFlashOnIcon.iconId = "10wV8k";
